import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import useApi from "../../hooks/useApi";
import { getDecodedToken } from "../../utils/helpers";

import Loader from "../../Components/Loader";
import ModalConfirmation from "../../Components/ModalConfirmation";
import CustomButton from "../../Components/CustomButton";
import ProviderRequestCard from "../../Components/ProviderRequestCard";

import "./style.scss";

const ProviderRequests = () => {
  const [navToggle, setNavToggle] = useState({
    pending: "pending",
    responded: "",
  });

  const [isModalOpen, setIsModalOpen] = useState("");
  const [requestsData, setRequestsData] = useState();
  const [requestId, setRequestId] = useState("");

  const { t } = useTranslation();
  const { get, put, loading } = useApi();

  const fetchRequests = async (params) => {
    try {
      const data = await get(
        `/Providers/Request?ProviderId=${getDecodedToken().buid}&Statuses=${params}`,
      );

      const formattedData = data.map((item) => ({
        id: item.id,
        consumerName: item.consumerName,
        creationDate: item.creationDate,
        consumerId: item.consumerId,
        consumerPhoneNumber: item.consumerPhoneNumber,
        consumerEmail: item.consumerEmail,
        description: item?.description,
        status: item.status,
        frequency: item.answers.frequency[0] || null,
        ages: item.answers.ages[0] || null,
        availability: item.answers.availability[0] || null,
      }));
      setRequestsData(formattedData);
    } catch (err) {
      console.log(err);
    }
  };

  const putStatus = async () => {
    // &Statuses=Read
    try {
      const data = await put(`/Providers/Request`, {
        id: requestId,
        status: "Read",
      });

      fetchRequests("pending");
    } catch (err) {
      console.log(err);
    }
  };

  const handleNavToggle = (text) => {
    if (text === "pending") {
      setNavToggle({
        pending: "pending",
        responded: "",
      });
      fetchRequests("Pending");
    } else {
      setNavToggle({
        pending: "",
        responded: "responded",
      });
      fetchRequests("Read");
    }
  };

  useEffect(() => {
    fetchRequests("Pending");
  }, []);

  return (
    <div className="provider-requests-container">
      <div className="requests-container-header">
        <h2>{t("your_requests")}</h2>
      </div>
      <div className="requests-container-navigation">
        <button
          className={navToggle.pending}
          onClick={() => {
            handleNavToggle("pending");
          }}
        >
          {t("new_requests")}
        </button>
        <button
          className={navToggle.responded}
          onClick={() => {
            handleNavToggle("responded");
          }}
        >
          {t("responded")}
        </button>
      </div>

      <div className={`nav-toggle ${navToggle.pending}`}>
        {requestsData && requestsData.length ? (
          requestsData.map((item) => {
            return (
              <ProviderRequestCard
                key={item.id}
                requesData={item}
                button={
                  <CustomButton
                    onClick={() => {
                      setRequestId(item.id);
                      setIsModalOpen("modal-confirm");
                    }}
                  >
                    {t("mark_as_responded")}
                  </CustomButton>
                }
              />
            );
          })
        ) : (
          <div className="empty_requests">
            <h2>{t("empty_pending_requests")}</h2>
          </div>
        )}
      </div>

      <div className={`nav-toggle ${navToggle.responded}`}>
        {requestsData && requestsData.length ? (
          requestsData.map((item) => {
            return <ProviderRequestCard key={item.id} requesData={item} />;
          })
        ) : (
          <div className="empty_requests">
            <h2>{t("empty_responded_requests")}</h2>
          </div>
        )}
      </div>

      {loading && <Loader />}

      <ModalConfirmation
        modalText={t("mark_as_responded_modal_header")}
        modalSubText={t("mark_as_responded_modal_subtext")}
        changeModal={setIsModalOpen}
        modalValue={isModalOpen}
        cancelButtonText={t("cancel")}
        confirmButtonText={t("confirm")}
        confirm={putStatus}
      />
    </div>
  );
};

export default ProviderRequests;
